import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import PageHero from '../shared/PageHero'
import { contentApi } from '../../services/contentApi'

const ServiceDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const [service, setService] = useState<Awaited<ReturnType<typeof contentApi.getService>> | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!id) return
    contentApi.getService(id)
      .then(setService)
      .catch(() => setService(null))
      .finally(() => setLoading(false))
  }, [id])

  if (loading) {
    return <div className="min-h-[50vh] flex items-center justify-center"><div className="animate-spin h-8 w-8 border-4 border-primary-500 border-t-transparent rounded-full" /></div>
  }

  if (!service) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <h1 className="text-2xl font-bold">Service not found</h1>
        <Link to="/services" className="mt-4 inline-block text-primary-600 font-medium">← Back to services</Link>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-white">
      <PageHero title={service.title} subtitle={service.summary} />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/services" className="inline-flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-primary-600 mb-8">
          <ArrowLeft className="h-4 w-4" /> All services
        </Link>
        <div
          className="prose prose-lg max-w-none prose-headings:text-gray-900 prose-a:text-primary-600"
          dangerouslySetInnerHTML={{ __html: service.content || `<p>${service.summary}</p>` }}
        />
        <div className="mt-10 p-6 rounded-2xl bg-primary-50 border border-primary-100">
          <p className="font-semibold text-gray-900">Ready to book?</p>
          <p className="text-sm text-gray-600 mt-1">Browse verified stays near Manauna Dham.</p>
          <Link to="/rooms?location=Manauna" className="mt-4 inline-block px-6 py-2.5 bg-primary-500 text-white font-semibold rounded-xl hover:bg-primary-600 transition-colors">
            Browse rooms
          </Link>
        </div>
      </article>
    </div>
  )
}

export default ServiceDetailPage
